import axios from "axios";
import { base_url } from "../config";

const accessToken = localStorage.getItem("@user");

export const fetchBookmarks = async () => {
  try {
    const response = await axios.get(`${base_url}/bookmark/list?limit=30`, {
      headers: {
        accept: "application/json, text/plain, */*",
        authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data.items;
  } catch (error) {
    console.error("Error fetching bookmarks:", error);
    throw error;
  }
};

const BASE_URL = `${base_url}/bookmark/create`;

export const addBookmark = async (tableId) => {
  try {
    const response = await axios.post(`${BASE_URL}?access_token=${accessToken}`, { table_id: tableId }, { headers: { "Content-Type": "application/json" } });
    return response.data;
  } catch (error) {
    console.error("Error adding bookmark:", error);
    throw error;
  }
};
